import unescapedText from 'I18n/utils/unescapedText';
import { View } from 'foundations-components/components/View';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useMemo } from 'react';
import { EcosystemSlider } from 'trellis-ecosystem';
import { CollectionCard } from '../../collections/components/CollectionCard';
import { Subscreens } from '../../constants/usage';
import { useFilterConfigData } from '../../filters/hooks/useFilterConfig';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { isQa } from '../../utils/env';
import { SUGGESTED_ACCREDITATIONS } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export function SuggestedAccreditations() {
  var _filterConfigResult$d;
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const filterConfigResult = useFilterConfigData();
  const trackCollectionCardClicked = (filter, index) => {
    var _filter$slug;
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'filter card clicked',
      category: (_filter$slug = filter.slug) !== null && _filter$slug !== void 0 ? _filter$slug : '',
      itemIndex: index,
      subscreen: Subscreens.SUGGESTED_ACCREDITATIONS
    }));
  };
  const trackSliderButtonClicked = direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggested filter section ${direction} arrow clicked`,
      // Hardcoded index based on figma design layout
      itemIndex: 2,
      subscreen: Subscreens.SUGGESTED_ACCREDITATIONS
    }));
  };
  const data = (_filterConfigResult$d = filterConfigResult.data) === null || _filterConfigResult$d === void 0 ? void 0 : _filterConfigResult$d.result.filterConfigs.PROFILE_CATALOG_SERVICES.options;
  const accreditations = useMemo(() => {
    if (!data) return [];
    if (isQa()) {
      return SUGGESTED_ACCREDITATIONS;
    }
    return SUGGESTED_ACCREDITATIONS.filter(filter => data.find(d => d.value === filter.value));
  }, [data]);
  if (!data || !accreditations.length) return null;
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1000",
    maxInlineSize: "100%",
    children: /*#__PURE__*/_jsx(EcosystemSlider, {
      cardWidth: 625,
      gradientColor: "fill-surface-recessed",
      onScrollButtonClick: trackSliderButtonClicked
      // I've eyeballed this so the center of the scroll buttons aligns with the bottom of the card image background
      ,
      scrollButtonTop: "43.5%",
      title: unescapedText('marketplaceStorefront.suggestedFilters.title'),
      description: unescapedText('marketplaceStorefront.suggestedFilters.description'),
      children: accreditations.map((accreditation, index) => {
        var _accreditation$descri, _accreditation$slug;
        return /*#__PURE__*/_jsx(CollectionCard, {
          buttonText: accreditation.buttonText || unescapedText('marketplaceStorefront.suggestedFilters.buttonText', {
            accreditation: accreditation.text
          }),
          description: (_accreditation$descri = accreditation.description) !== null && _accreditation$descri !== void 0 ? _accreditation$descri : '',
          href: `/solutions/${accreditation.slug}`,
          name: accreditation.text,
          onClick: () => {
            trackCollectionCardClicked(accreditation, index);
            scrollToTop();
          },
          slug: (_accreditation$slug = accreditation.slug) !== null && _accreditation$slug !== void 0 ? _accreditation$slug : ''
        }, accreditation.slug);
      })
    })
  });
}